import React, { useEffect } from 'react';
import { TOAST_DURATION_MS } from '../../constants/toast';

// BIGLI-24：每一則提醒各自停留 5 秒後自動消失（計時器就掛在這裡，不是掛在整個堆疊上，
// 所以連續跳多則時每則都從自己出現的時間點起算）。X 關閉鈕保留，使用者仍可提前關掉。
//
// 兩個 props 都必須是穩定的（onClose 直接用 context 的 removeToast，不要在
// ToastContainer 裡包 inline arrow），否則父層每 render 一次就換一個新函式，
// 下面的 effect 會跟著重跑、計時器被重置，5 秒永遠倒數不完。
const Toast = ({ toast, onClose }) => {
  const { id } = toast;

  useEffect(() => {
    const timer = setTimeout(() => onClose(id), TOAST_DURATION_MS);
    // 卸載（換頁、按 X 手動關閉、Shift+ESC 清空）時一律清掉自己的計時器：
    // 既避免 unmount 後 setState 警告，也避免這則的計時器活過自己的壽命，
    // 之後誤刪到剛好拿到同一個 id 的新 toast。
    return () => clearTimeout(timer);
  }, [id, onClose]);

  return (
    <div className={`toast toast-${toast.type}`} role="alert">
      <div className="toast-content">
        {toast.type === 'success' && <span className="toast-icon success-icon">✓</span>}
        {toast.type === 'error' && <span className="toast-icon error-icon">✗</span>}
        {toast.type === 'info' && <span className="toast-icon info-icon">ℹ</span>}
        {toast.type === 'warning' && <span className="toast-icon warning-icon">⚠</span>}
        <span className="toast-message">{toast.message}</span>
      </div>
      <button
        type="button"
        className="toast-close"
        onClick={() => onClose(id)}
        aria-label="關閉這則提醒"
        title="關閉這則提醒"
      >
        ×
      </button>
    </div>
  );
};

export default Toast;
